module.exports = __webpack_public_path__ + "img/nipanan-lifestyle-pV2xU2rP580-unsplash.b9efc09f.jpg";